<template>
  <v-dialog
    v-model="showDialog"
    max-width="800"
  >
    <v-card>
      <v-toolbar
        dense
        color="elevation-0"
      >
        <v-btn
          icon
          color="black"
          @click.native="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-row no-gutters>
        <v-col cols="12">
          <v-row
            no-gutters
            align="center"
            justify="center"
          >
            <v-img
              v-if="src.length"
              :src="src"
              max-width="600"
              max-height="600"
              contain
            />
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    }
  },

  methods: {
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>
